import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Toolbar from '@material-ui/core/Toolbar';
import { ExitToApp } from '@material-ui/icons';
import { getAuth, signOut } from "firebase/auth";
import routes from '../routes/routes'

const NavBar = () => {
    const logOut = () => {
        const auth = getAuth();
        signOut(auth);
    };


    return (
        <AppBar position="static" >
            <Toolbar>
                <IconButton
                    onClick={logOut}
                    edge="start"
                    color="inherit"
                    aria-label="exit"
                >
                    <ExitToApp />
                </IconButton>
                <Grid
                    container
                    spacing={3}
                >
                    <Grid item xs={3}>
                        <Link color="inherit" href={routes.homeRouteName}>
                            Home
                        </Link>
                    </Grid>
                    <Grid item xs={3}>
                        <Link color="inherit" href={routes.tellMeHomeRouteName}>
                            Tell Me
                        </Link>
                    </Grid>
                    <Grid item xs={3}>
                        <Link color="inherit" href={routes.tellMeWatchRouteName}>
                            Tell Me Watch
                        </Link>
                    </Grid>
                    <Grid item xs={3}>
                        <Link color="inherit" onClick={() => { console.log("NOT YET") }}>
                            New Apps...
                        </Link>
                    </Grid>

                </Grid>

            </Toolbar>
        </AppBar>
    );
};

export default NavBar;